/* eslint-disable */
import axiosIns from '@/libs/axios'
import AdminAuth from './admin-auth'

const setup = () => {
  axiosIns.interceptors.request.use(
    async config => {
      const adminAuth = new AdminAuth()
      const session = await adminAuth.currentSession()
      let token;
      if (session) {
        token = session.getIdToken().getJwtToken()
      }
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
      return config
    },
    error => Promise.reject(error),
  )

  axiosIns.interceptors.response.use(
    async res => res,
    async err => {
      const originalConfig = err.config

      if (err.response) {
        // Access Token was expired
        if (err.response.status === 401 && !originalConfig._retry) {
          originalConfig._retry = true

          try {
            const adminAuth = new AdminAuth()
            await adminAuth.refreshSession()

            return axiosIns(originalConfig)
          } catch (_error) {
            return Promise.reject(_error)
          }
        }
      }

      return Promise.reject(err)
    },
  )
}

export default setup

/* eslint-enable */
